module.exports = __webpack_public_path__ + "static/Plain-Regular-33157b35793cb97e5b2454196471a06e.woff";